/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/forbid-prop-types */
import * as React from 'react';
import PropTypes from 'prop-types';
import querystring from 'querystring';

import { cssMQ } from 'common/utils';
import { IS_DEVEL } from 'client/constants';

export default class MakoAnalytics extends React.PureComponent {
	static propTypes = {
		vcmId: PropTypes.string.isRequired,
	};

	static passedIds = [];

	renderAnalyticsIframe() {
		const srcBase = 'https://mobileapp.mako.co.il/metricsCall.html';
		const channelId = 'f6750a2610f26110VgnVCM1000005201000aRCRD';
		// eslint-disable-next-line camelcase
		const mako_ExternalProjectID = 'EX_glglz_V1';
		const isMobile = cssMQ.isMobile();
		const platform = isMobile ? 'mobile' : 'web';
		const { vcmId } = this.props;
		const isMainPage = vcmId === 'HP';
		const contentType = isMainPage ? 'HP' : 'content';
		const ref = document.referrer || '';

		const params = {
			vcmId,
			contentType,
			channelId,
			mako_ExternalProjectID,
			platform,
			ref,
		};

		const src = `${srcBase}?${querystring.stringify(params)}`;
		return (
			// putting styles inside an <object /> or an <embed />
			// breaks them in chrome no matter how you insert them
			<object type="text/html" data={src} width="0" height="0" />
		);
	}

	render() {
		if (IS_DEVEL || MakoAnalytics.passedIds[this.props.vcmId]) return null;
		MakoAnalytics.passedIds[this.props.vcmId] = true;

		return this.renderAnalyticsIframe();
	}
}
